import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import classes from './styles.module.scss';

export default function Tabs({ currentTab, setCurrentTab }) {
  const { t } = useTranslation();

  const tabs = [
    t('dashboardComponents.Companies.CompanyDetails.details'),
    t('dashboardComponents.Companies.CompanyDetails.activites'),
    // t('dashboardComponents.Companies.CompanyDetails.rules'),
    t('dashboardComponents.Companies.CompanyDetails.settings'),
  ];

  return (
    <div className={classes.Tabs}>
      {tabs.map((tab) => (
        <div
          className={classNames(classes.tab, {
            [classes.active]: currentTab === tab,
          })}
          key={tab}
          onClick={() => setCurrentTab(tab)}
        >
          {tab}
        </div>
      ))}
    </div>
  );
}
